import { createFileRoute } from '@tanstack/react-router';
import TemplateListView from '../bulk-import/templates/list/template-list-view';
export const Route = createFileRoute('/bulk-import/templates/')({ component: TemplateListView });
